import React, { useMemo, useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Box from '@material-ui/core/Box';
import { useIntl } from 'umi';
// import DesktopDateRangePicker from '@material-ui/lab/DesktopDateRangePicker';
import MobileDateRangePicker from '@material-ui/lab/MobileDateRangePicker';
import dayjs from 'dayjs';
import { getType } from '@/utils/comUtil';

import DateRangePickerMLStyled from './DateRangePickerMLStyled';

/**
 *
 * @param {isReset} 是否清除所有值
 * @param {isResetDefalut} 是否重置到默认状态
 * @param {resetStartDate} 重置开始日期。默认当天
 * @param {resetEndDate} 重置结束日期。默认当天
 * @param {afterDays} 限制开始日期多少天后为结束日期
 * @returns
 */

function getNextDate(date, day) {
  const dd = new Date(date);
  dd.setDate(dd.getDate() + day);
  const y = dd.getFullYear();
  const m =
    dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1;
  const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
  return y + '-' + m + '-' + d;
}
export default function DateRangePickerML({
  startText = '开始时间',
  endText = '结束时间',
  title,
  disabled = false,
  rp = { onChange: () => {} },
  // maxDate = undefined,
  minDate = undefined,
  defaultStartDate = null,
  defaultEndDate = null,
  isReset = false,
  isResetDefalut = false,
  resetStartDate = dayjs().format('YYYY-MM-DD'),
  resetEndDate = dayjs().format('YYYY-MM-DD'),
  onChange = () => {},
  handleClearStartDateCall,
  afterDays,
  isBefore,
}) {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const intl = useIntl();
  const { formatMessage } = intl;
  useMemo(() => {
    isResetDefalut && setStartDate(dayjs(resetStartDate).format('YYYY-MM-DD'));
    isResetDefalut && setEndDate(dayjs(resetEndDate).format('YYYY-MM-DD'));
  }, [isResetDefalut]);

  const disposeDate = ({
    defaultDate,
    resetDate,
    rawDate,
    reset,
    resetDefalut,
  }) => {
    if (reset) {
      return null;
    }
    if (resetDefalut) {
      return isBefore
        ? getNextDate(dayjs(resetDate).format('YYYY-MM-DD'), -1)
        : dayjs(resetDate).format('YYYY-MM-DD');
    }
    return rawDate || getType(rawDate) === 'Null' ? rawDate : defaultDate;
  };

  const formatDate = (rawDate) => {
    const dateFmt =
      dayjs(rawDate).format('YYYY-MM-DD') === 'Invalid Date'
        ? null
        : dayjs(rawDate).format('YYYY-MM-DD');
    return dateFmt;
  };

  useEffect(() => {
    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
  }, [defaultStartDate, defaultEndDate]);

  const validStartDate = useMemo(() => {
    return disposeDate({
      defaultDate: defaultStartDate
        ? dayjs(defaultStartDate).format('YYYY-MM-DD')
        : null,
      resetDate: resetStartDate,
      rawDate: startDate,
      reset: isReset,
      resetDefalut: isResetDefalut,
    });
  }, [defaultStartDate, resetStartDate, startDate, isReset, isResetDefalut]);

  const validEndDate = useMemo(() => {
    return disposeDate({
      defaultDate: defaultEndDate
        ? dayjs(defaultEndDate).format('YYYY-MM-DD')
        : null,
      resetDate: resetEndDate,
      rawDate: endDate,
      reset: isReset,
      resetDefalut: isResetDefalut,
    });
  }, [defaultEndDate, resetEndDate, endDate, isReset, isResetDefalut]);

  const handleChange = (seletedDate) => {
    const [sDate, eDate] = seletedDate;
    setStartDate(sDate);
    setEndDate(eDate);
    const fmtStartDate = formatDate(sDate);
    const fmtEndDate = formatDate(eDate);
    onChange({ startDate: fmtStartDate, endDate: fmtEndDate, reset: false });
    return rp.onChange({ startDate: fmtStartDate, endDate: fmtEndDate });
  };

  //清空开始时间
  const handleClearStartDate = () => {
    const fmtEndDate = formatDate(endDate);
    setStartDate(null);
    onChange({ startDate: null, endDate: fmtEndDate, reset: false });
    handleClearStartDateCall &&
      handleClearStartDateCall({ startDate: null, endDate: fmtEndDate });
    return rp.onChange({ startDate: null, endDate: fmtEndDate });
  };
  //清空结束时间
  const handleClearEndDate = () => {
    const fmtStartDate = formatDate(startDate);
    setEndDate(null);
    onChange({ startDate: fmtStartDate, endDate: null, reset: false });
    handleClearStartDateCall &&
      handleClearStartDateCall({ startDate: fmtStartDate, endDate: null });
    return rp.onChange({ startDate: fmtStartDate, endDate: null });
  };

  // 获取指定天数后日期
  const getDaysAfter = (date, amount) => {
    return date && amount ? dayjs(date).add(amount, 'day').toDate() : undefined;
  };
  return (
    <DateRangePickerMLStyled>
      <MobileDateRangePicker
        mask={'____-__-__'}
        showToolbar={!handleClearStartDateCall}
        showDaysOutsideCurrentMonth
        // disableCloseOnSelect={true}
        disabled={disabled}
        calendars={2}
        toolbarTitle={title ?? formatMessage({ id: 'cm.analysis.d01.rdo01' })}
        startText={startText}
        endText={endText}
        okText={formatMessage({ id: 'comm.action.btn.07' })}
        cancelText={formatMessage({ id: 'comm.action.btn.08' })}
        clearText={'清除'}
        value={[validStartDate, validEndDate]}
        inputFormat="yyyy-MM-dd"
        // clearable
        maxDate={getDaysAfter(validStartDate, afterDays)}
        // maxDate={'2021-10-22'}
        minDate={minDate}
        onChange={(e) => {
          handleChange(e);
        }}
        renderInput={(startProps, endProps) => (
          <React.Fragment>
            <TextField
              {...startProps}
              fullWidth
              variant="standard"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={handleClearStartDate}
                      edge="end"
                    >
                      {!disabled && validStartDate ? (
                        <ClearIcon className="clear-icon" />
                      ) : (
                        ''
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Box sx={{ mx: 2 }}>
              {' '}
              {formatMessage({ id: 'cm.analysis.n01.txt03' })}{' '}
            </Box>
            <TextField
              {...endProps}
              fullWidth
              variant="standard"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={handleClearEndDate}
                      edge="end"
                    >
                      {!disabled && validEndDate ? (
                        <ClearIcon className="clear-icon" />
                      ) : (
                        ''
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </React.Fragment>
        )}
      />
    </DateRangePickerMLStyled>
  );
}
